var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import { Box, Grid, Toolbar, Divider, Typography, Container, } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { account as api, session } from '../api';
import { useNotify } from '../hooks/notificationHook';
import { useRequest } from '../hooks/requestHook';
import { getCurrentUser, setCurrentUser } from '../localStorage';
import TextField from './atoms/TextField';
import BaseButton from './atoms/BaseButton';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var ContentWrapper = styled.form(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 20px 30px;\n"], ["\n  margin: 20px 30px;\n"])));
var CurrentEmailContainer = styled(Container)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &.MuiContainer-root {\n    margin-bottom: 24px;\n  }\n"], ["\n  &.MuiContainer-root {\n    margin-bottom: 24px;\n  }\n"])));
var isValidEmail = function (email) {
    var regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regexp.test(email.toLowerCase());
};
var AccountEditForm = function (_a) {
    var role = _a.role;
    var t = useTranslation().t;
    var notify = useNotify();
    var navigate = useNavigate();
    var currentUser = getCurrentUser();
    var updateAccountEmail = useRequest(api.updateAccountEmail);
    var _b = React.useState(), email = _b[0], setEmail = _b[1];
    var invalidEmail = React.useMemo(function () { return email !== undefined && email !== '' && !isValidEmail(email); }, [email]);
    var handleSubmitEmail = React.useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (!email)
                        return [2 /*return*/];
                    return [4 /*yield*/, updateAccountEmail({ role: role, email: email })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    notify('success', [t('messages.accountUpdateSuccess')]);
                    return [4 /*yield*/, session.logout()];
                case 2:
                    _a.sent();
                    navigate("/".concat(role, "/login"));
                    return [2 /*return*/];
            }
        });
    }); }, [navigate, notify, email, role, t, updateAccountEmail]);
    var updateAccount = useRequest(api.updateAccount);
    var _c = React.useState({
        name: currentUser.name,
    }), formData = _c[0], setFormData = _c[1];
    var handleSubmitUpdate = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var updated;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateAccount({ user: formData })];
                case 1:
                    updated = _a.sent();
                    if (!updated)
                        return [2 /*return*/];
                    setCurrentUser(updated);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [notify, formData, t, updateAccount]);
    return (React.createElement(Wrapper, null,
        React.createElement(Toolbar, null,
            React.createElement(Typography, { variant: "h5" }, t('pages.editAccount.title'))),
        React.createElement(ContentWrapper, null,
            React.createElement(CurrentEmailContainer, { maxWidth: "md" },
                React.createElement(Typography, { variant: "h6" }, "".concat(t('pages.editAccount.currentEmail'), ": ").concat(currentUser.email)),
                React.createElement(Divider, null)),
            React.createElement(Container, { maxWidth: "md" },
                React.createElement(Typography, { variant: "body1", style: { whiteSpace: 'pre-wrap' } }, t('pages.editAccount.warning')),
                React.createElement(Divider, null),
                React.createElement(Grid, { container: true, spacing: 3, style: { marginTop: 5 } },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { type: "email", error: invalidEmail, helperText: invalidEmail ? t('messages.invalidEmail') : '', placeholder: "user@example.com", label: t('email'), value: email, fullWidth: true, onChange: function (ev) { return setEmail(ev.target.value); }, onKeyDown: function (event) {
                                if (event.key === 'Enter')
                                    event.preventDefault();
                            } })),
                    React.createElement(Grid, { item: true, xs: 1 }),
                    React.createElement(Grid, { item: true, xs: 10 },
                        React.createElement(BaseButton, { fullWidth: true, onClick: handleSubmitEmail, disabled: !email || invalidEmail }, t('buttons.update')))),
                role === 'admin' && (React.createElement(Box, { mt: 4 },
                    React.createElement(Divider, null),
                    React.createElement(Grid, { container: true, spacing: 3, style: { marginTop: 5 } },
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { label: t('labels.forumDisplayName'), value: formData.name, fullWidth: true, onChange: function (ev) {
                                    return setFormData(__assign(__assign({}, formData), { name: ev.target.value }));
                                } })),
                        React.createElement(Grid, { item: true, xs: 1 }),
                        React.createElement(Grid, { item: true, xs: 10 },
                            React.createElement(BaseButton, { fullWidth: true, onClick: handleSubmitUpdate }, t('buttons.update'))))))))));
};
export default AccountEditForm;
var templateObject_1, templateObject_2, templateObject_3;
